import { Grid } from "@mui/material";
import { useReducer } from "react";
import ChangePasswordForm from "./ChangePasswordForm";
import { Messages } from "./settingsTypes";
import UserInfoForm from "./UserInfoForm";

const submittedMessages: Messages = {
  contact: "",
  password: "",
};

const Settings = () => {
  const [messagesState, setMessagesState] = useReducer(
    (curVals: any, newVals: any) => ({ ...curVals, ...newVals }),
    submittedMessages
  );
  const setContactMessage = (message: string) => {
    setMessagesState({ contact: message });
  };
  const setPasswordMessage = (message: string) => {
    setMessagesState({ password: message });
  };
  return (
    <Grid container spacing={6} justifyContent="flex-start">
      <UserInfoForm
        messagesState={messagesState}
        setMessage={setContactMessage}
      />
      <ChangePasswordForm
        messagesState={messagesState}
        setMessage={setPasswordMessage}
      />
    </Grid>
  );
};

export default Settings;
